import request from '@/utils/request'

/**
 * 查询导购员订单统计列表
 * @param {Object} params - 查询参数
 * @param {Number} params.current - 当前页
 * @param {Number} params.size - 每页数量
 * @param {String} params.month - 统计月份(格式: yyyy-MM)
 * @param {String} params.guideMobile - 导购员手机号
 */
export function getGuideOrderStatistics(params) {
  return request({
    url: '/statistics/order/guide/list',
    method: 'get',
    params: params
  })
}

/**
 * 查询导购要货统计列表
 * @param {Object} params - 查询参数
 * @param {Number} params.pageNo - 当前页
 * @param {Number} params.pageSize - 每页数量
 * @param {String} params.month - 统计月份(格式: yyyy-MM)
 * @param {String} params.guideMobile - 导购员手机号
 * @param {Number} params.merchantId - 商家ID
 * @param {Number} params.settleStatus - 结算状态
 */
export function getGuidePurchaseStatisticsList(params) {
  return request({
    url: '/api/retail/statistics/guide-purchase/list',
    method: 'get',
    params: params
  })
}

/**
 * 查询导购要货统计详情
 * @param {Object} params - 查询参数
 * @param {Number} params.id - 统计记录ID
 */
export function getGuidePurchaseStatisticsDetail(params) {
  return request({
    url: '/api/retail/statistics/guide-purchase/detail',
    method: 'get',
    params: params
  })
}

/**
 * 结算导购要货统计
 * @param {Object} data - 请求数据
 * @param {Number} data.id - 统计记录ID
 */
export function settleGuidePurchaseStatistics(data) {
  return request({
    url: '/api/retail/statistics/guide-purchase/settle',
    method: 'post',
    data: data
  })
}

